'use strict';

var availabilityStatusPill = require('../../../../../../../../../../_virtual/availabilityStatusPill.cjs');

var hasRequiredAvailabilityStatusPill;

function requireAvailabilityStatusPill () {
	if (hasRequiredAvailabilityStatusPill) return availabilityStatusPill.__exports;
	hasRequiredAvailabilityStatusPill = 1;

	var AVAILABILITY_STATUS_PILL_AVIARY_SIZES = /*#__PURE__*/ function(AVAILABILITY_STATUS_PILL_AVIARY_SIZES) {
	    AVAILABILITY_STATUS_PILL_AVIARY_SIZES["xxsmall"] = "xxsmall";
	    AVAILABILITY_STATUS_PILL_AVIARY_SIZES["xsmall"] = "xsmall";
	    AVAILABILITY_STATUS_PILL_AVIARY_SIZES["small"] = "small";
	    return AVAILABILITY_STATUS_PILL_AVIARY_SIZES;
	}({});

	availabilityStatusPill.__exports.AVAILABILITY_STATUS_PILL_AVIARY_SIZES = AVAILABILITY_STATUS_PILL_AVIARY_SIZES;
	
	return availabilityStatusPill.__exports;
}

exports.__require = requireAvailabilityStatusPill;
//# sourceMappingURL=availabilityStatusPill.cjs.map
